module.exports = __webpack_public_path__ + "static/img/mzjg_back.png";